export const CardBackMark = () => (
  <span className="card-back-mark" aria-hidden="true">
    <i className="card-back-mark__card card-back-mark__card--blue" />
    <i className="card-back-mark__card card-back-mark__card--yellow" />
    <i className="card-back-mark__card card-back-mark__card--coral" />
  </span>
);
